import React from 'react'
import Helmet from 'react-helmet'
import Page from '../components/Page'

export default () => (
  <Page className="container">
    <h1>404?!</h1>
    <Helmet title='404' />
  </Page>
)


// WEBPACK FOOTER //
// ./src/views/NoMatch.js